<template>
  <div v-if="$root.selectedShopCount > 0">
    <div class="fixedSelectionList pcOnly">
      <div class="fixedSelectionList__text">問い合わせリストに追加した<span class="count">{{ $root.selectedShopCount }}</span>件に</div>
      <div class="fixedSelectionList__button">
        <marunage-button button-class="orange" :bulk="true" form-name-prefix="pc_marunage_button_"><i class="heart outline icon"></i>まとめて問い合わせ</marunage-button>
      </div>
      <div class="fixedSelectionList__button">
        <button class="ui button basic orange" @click="location.href = '/checklist'">問い合わせリスト確認</button>
      </div>
    </div>
    <div class="fixedSelectionList spOnly">
      <div class="fixedSelectionList__text">問い合わせリスト<span class="count">{{ $root.selectedShopCount }}</span>件</div>
      <div class="fixedSelectionList__button">
        <marunage-button button-class="orange" :bulk="true" form-name-prefix="sp_marunage_button_">まとめて問合せ</marunage-button>
      </div>
      <div class="fixedSelectionList__button">
        <a href="/checklist">リスト確認</a>
      </div>
    </div>
  </div>
</template>

<script>
import MarunageButton from "./marunageButton.vue";

export default {
  components: {
      'marunage-button': MarunageButton
  }
};
</script>
